import SideBar from "../side-bar/side-bar";
import TopHeader from "../top-header/top-header";

const Navbar = () => {
  return (
    <div>
      <div className="clsTopHeader">
        <TopHeader></TopHeader>
      </div>
      <div className="clsLeftNav slideInLeft">
        <SideBar></SideBar>
      </div>
    </div>
  );
};
export default Navbar;
